import { patchApiRequest } from 'api';

export const changeNewsElementsOrdering = (id: number, ordering: number[]): Promise<{ ordering: number[] }> => {
    return patchApiRequest(`/news/${id}/element-ordering/`, { ordering });
};
